import ContactSection from '../ContactSection';

export default function Contact() {
  return <ContactSection id="contact" />;
}
